export const NAME = 'invoices';
